export default __webpack_public_path__ + "static/media/coin.32c3a572.png";